import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "व्यावसायिक",
  icon: "💼",
  templates: [
    {
      title: "YouTube / वीडियो स्क्रिप्ट",
      content: `एक YouTube वीडियो के लिए स्क्रिप्ट लिखें जो एक व्यक्ति द्वारा सुनाई जाए।
- वीडियो का विषय है [घर से काम करते समय लोग जो 5 आम गलतियाँ करते हैं — और उन्हें कैसे ठीक करें]।
- लक्षित दर्शक: [अपनी पहली रिमोट नौकरी शुरू करने वाले युवा पेशेवर]।
- स्वर: [मैत्रीपूर्ण, बातचीत जैसा और व्यावहारिक — जैसे एक भरोसेमंद सहकर्मी की सलाह]।
- पहले दो वाक्यों में मजबूत हुक, बिंदुओं के बीच स्पष्ट संक्रमण, और कार्रवाई के आह्वान के साथ एक संक्षिप्त समापन के साथ संरचित करें।
- बोलने के लिए लिखें: श्रोता का ध्यान बनाए रखने के लिए छोटे अनुच्छेदों और अलंकारिक प्रश्नों का उपयोग करें।`
    },
    {
      title: "उत्पाद व्याख्या",
      content: `एक उत्पाद व्याख्या वीडियो के लिए वॉयसओवर स्क्रिप्ट लिखें।
- उत्पाद है [एक मोबाइल ऐप जो छोटे व्यापार मालिकों को रसीदें स्कैन करके खर्चों को ट्रैक करने में मदद करता है]।
- लक्षित दर्शक: [फ्रीलांसर और छोटे व्यापार मालिक जो बहीखाता पद्धति से नफरत करते हैं]।
- मुख्य लाभ जो उजागर करने हैं:
  1. [2 सेकंड में रसीद स्कैन करें — कोई मैनुअल प्रविष्टि नहीं]।
  2. [स्मार्ट सुझावों के साथ स्वचालित खर्च श्रेणियाँ]।
  3. [कर सीज़न के लिए एक-टैप निर्यात]।
- स्वर: [स्पष्ट, उत्साहित और आश्वस्त करने वाला — यह एक कठिन कार्य को आसान बनाता है]।
- वाक्य संक्षिप्त और प्रभावशाली रखें। शब्दजाल से बचें।`
    },
    {
      title: "प्रस्तुति भाषण",
      content: `एक पेशेवर प्रस्तुति या मुख्य भाषण लिखें।
- अवसर है [एक नई तिमाही शुरू करने के लिए कंपनी की ऑल-हैंड्स मीटिंग]।
- वक्ता है [एक टीम लीड जो इंजीनियरों, डिज़ाइनरों और प्रबंधकों के मिश्रित दर्शकों को संबोधित कर रहा है]।
- मूल संदेश: [पिछली तिमाही की जीत का जश्न मनाना, चुनौतियों को ईमानदारी से स्वीकार करना, और आने वाले महीनों के लिए एक स्पष्ट फोकस के इर्द-गिर्द टीम को एकजुट करना]।
- स्वर: [आत्मविश्वासी, सच्चा और प्रेरक — कॉर्पोरेट भाषा नहीं]।
- अनुमानित बोलने की अवधि: [4 मिनट]।
- बातचीत की भाषा, रणनीतिक विराम और एक यादगार समापन पंक्ति का उपयोग करें।`
    }
  ]
};
